import { render, staticRenderFns } from "./HotelManager.vue?vue&type=template&id=842efc30"
import script from "./HotelManager.vue?vue&type=script&lang=js"
export * from "./HotelManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports